// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems_NavigationItems__3feKW","icon":"NavigationItems_icon__1lN7g"};